import { useContext } from 'react'
import { CompanyContext } from '@/context/CompanyContext'

export function useCompany() {
  const company = useContext(CompanyContext)
  return company
}
